import { AuthContextState } from "./auth-context";
import { USER_KEY, ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from "./auth-context-vars";

function AuthContextReducer(state: AuthContextState, action: any) {
    switch(action.type) {
        case "LOGIN":
            localStorage.setItem(USER_KEY, action.payload.user);
            localStorage.setItem(ACCESS_TOKEN_KEY, action.payload.accessToken);
            localStorage.setItem(REFRESH_TOKEN_KEY, action.payload.refreshToken);
            return {
                ...state,
                user: action.payload.user,
                canLogin: true,
            };
        case "LOGOUT":
            localStorage.setItem(USER_KEY, "");
            localStorage.setItem(ACCESS_TOKEN_KEY, "");
            localStorage.setItem(REFRESH_TOKEN_KEY, "");
            return {
                ...state,
                user: "",
                canLogin: false,
            };
        default:
            return state;
    }

}

export default AuthContextReducer;